import { createContext, useContext, useState, type ReactNode } from 'react';

interface BottomTabContextType {
  hideBottomTab: boolean;
  hideBottomTabShadow: boolean;
  setHideBottomTab: (hide: boolean) => void;
  setHideBottomTabShadow: (hide: boolean) => void;
  /**
   * Nó do slot de ação dentro do rodapé das abas (PersistentBottomTab), onde o
   * BottomActionBar entra por portal. `null` enquanto o rodapé não está na
   * tela. Registrado pelo próprio rodapé via ref, então quem consome re-renderiza
   * assim que o nó existe — sem procurar no DOM nem correr contra a montagem.
   */
  actionSlot: HTMLElement | null;
  setActionSlot: (slot: HTMLElement | null) => void;
}

const BottomTabContext = createContext<BottomTabContextType | undefined>(undefined);

export function useBottomTab() {
  const context = useContext(BottomTabContext);
  if (context === undefined) {
    throw new Error('useBottomTab must be used within a BottomTabProvider');
  }
  return context;
}

interface BottomTabProviderProps {
  children: ReactNode;
}

export function BottomTabProvider({ children }: BottomTabProviderProps) {
  const [hideBottomTab, setHideBottomTab] = useState(false);
  const [hideBottomTabShadow, setHideBottomTabShadow] = useState(false);
  const [actionSlot, setActionSlot] = useState<HTMLElement | null>(null);

  return (
    <BottomTabContext.Provider
      value={{
        hideBottomTab,
        hideBottomTabShadow,
        setHideBottomTab,
        setHideBottomTabShadow,
        actionSlot,
        setActionSlot,
      }}
    >
      {children}
    </BottomTabContext.Provider>
  );
}
